import React from 'react';

// AI marker per the Glyph icon style: outlined sparkle, 1.75px stroke.
// `withPlus` adds the small plus used on action buttons; chips use the plain sparkle.
export const SparkleIcon = ({ color = 'currentColor', size = '16px', className = '', withPlus = true }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 4l1.8 4.9L19 10.5l-5.2 1.6L12 17l-1.8-4.9L5 10.5l5.2-1.6z" />
    {withPlus && <path d="M18.5 15.5v4M16.5 17.5h4" />}
  </svg>
);

export default SparkleIcon;
